import React, {Component} from 'react';
import {
  ResponsiveContainer, PieChart, Pie, Tooltip, Cell,
} from 'recharts';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (props) => {
  const {cx, cy, midAngle, outerRadius, percent, innerRadius, payload} = props;

  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const alias = payload.aliasName ? `${payload.aliasName}: ` : '';

  return (
    <text x={x} y={y} fill='white' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
      {`${alias} ${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

class PieChartInSalesByAgencies extends Component {
  formatValue(value) {
    const valueFormmated = getNumericValue(value, 2);
    return `$${valueFormmated}`;
  }

  changeFillColor() {
    const {data} = this.props;
    return (
      data.map((entry, index) => <Cell key={index} fill={entry.color}/>)
    );
  }
  
  render() {
    const {data} = this.props;
    return (
      <ResponsiveContainer width='100%' height={500}>
        <PieChart>
          <Pie
            nameKey='name'
            dataKey='amount'
            data={data}
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={230}
            fill="#8884d8"
          >
            {this.changeFillColor()}
          </Pie>
          <Tooltip formatter={this.formatValue} />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}

export default PieChartInSalesByAgencies;
